export const API_BASE_URL = window._ENV_.REACT_APP_API_BASE_URL
export const API_EXTERNAL_URL = window._ENV_.REACT_APP_API_EXTERNAL_URL

export const CALL_API = "middleware@CALL_API"

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
}
